import { Box, Container, Paper, Stack, useMediaQuery } from '@mui/material'
import { EmailCampaignEmployeeCommuteForm } from '../components/employee/email-campaign-employee-commute-form'
import gaiaTheme from '../../../root-components/theme';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import { CustomThemeContext } from '../../../context/theme/custom-theme-context';

export const SurveyPage = () => {

  const { id } = useParams();
  const isMobileModeMd = useMediaQuery(gaiaTheme.breakpoints.down('md'));
  const customThemeContext = useContext(CustomThemeContext);

  return (
    <Box style={{ backgroundColor: '#F0F1F3', minHeight: '100vh' }}>
      <Stack display='flex' justifyContent='center' alignItems='center'>
        <Container maxWidth="md" sx={{ mt: 2, mb: 6 }}>
          <img
            src={customThemeContext.logoUrl}
            alt="GAIA logo"
            height="50"
            style={{ verticalAlign: 'middle', paddingLeft: '40px', paddingBottom: '15px' }}
          />
          <Paper variant='outlined'
            sx={{
              p: 0,
              display: 'flex',
              flexDirection: 'column',
              height: 'auto',
              width: '90%',
            }}
          >
            <Box sx={{ pl: isMobileModeMd ? 3 : 6, pr: isMobileModeMd ? 3 : 6, pt: isMobileModeMd ? 3 : 4, pb: isMobileModeMd ? 3 : 4, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {id === 'employee' && <EmailCampaignEmployeeCommuteForm />}
            </Box>
          </Paper>
        </Container>
      </Stack>
    </Box>
  )
}